import { bulkDeleteConsignmentItemsV3 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function bulkDeleteConsignmentItems(ids: number[]): Promise<void> {
  await bulkDeleteConsignmentItemsV3({ consignmentItemIds: ids })
}
